<template>
    <div class="city">
        <ul>
            <li v-for="(item,index) in cityArr" @click="backFn(index)" :key="index">
                {{item}}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'helloworld',
    data() {
        return {
           cityArr:['北京','上海','广州','深圳','茂名','张家界','清远','汕头','佛山'] 
        }
    },
    methods: {
        backFn:function(index){
            this.$store.dispatch('setCityName', this.cityArr[index])
            this.$router.go(-1)
        }
    },

}
</script>
<style lang="less">
.city{
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/city/cityList.vue